<template>
  <div class="tierbox" :style="parentStyle">
    <template v-if="hasData">
      <div
        v-for="(item, index) in dataChart"
        :key="index"
        class="tier"
        @click="goLink(item.name, item.value)"
      >
        <div class="tiertext">
          <div class="circle" :style="getcircle(index)"></div>
          <span :style="tiername">{{ item.name }}</span>
        </div>
        <div class="line"></div>
        <div :style="getTirec(item, index)" class="valuediv">
          <span class="value" :style="tierValue">{{ item.value }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <empty></empty>
    </template>
  </div>
</template>
<script>
import init from '@/mixins/chart';
export default {
  name: 'tier',
  props: {
    option: Object,
    component: Object
  },
  mixins: [init],
  computed: {
    parentStyle() {
      return {
        height: this.component.height + 'px',
        width: this.component.width + 'px',
        lineHeight: this.option.tagLineHeight
      };
    },
    tiername() {
      return {
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: (this.option.fontSize || 20) + 'px',
        color: this.option.color || '#fff'
      };
    },
    hasData() {
      return this.dataChart.length > 0;
    },
    tierValue() {
      return {
        fontWeight: this.option.valuefontWeight || 'normal',
        fontSize: (this.option.valuefontSize || 20) + 'px',
        color: this.option.valueColor || '#fff'
      };
    }
  },
  methods: {
    //小圆圈的背景
    getcircle(index) {
      return {
        boxShadow: 'inset 0px -5px 60px 3px ' + this.option.barColor[index].color1 || [],
        background: this.option.barColor[index].color1 || []
      };
    },
    //大圆圈的背景
    getTirec(item, index) {
      if (index == 0) {
        return {
          background: this.option.barColor[index].color1 || [],
          boxShadow: 'inset 0px -5px 16px 3px ' + this.option.barColor[index].color1 || [],
          width: 30 + '%',
          height: 20 + '%',
          textAlign: this.option.textAlign
        };
      } else if (index == 1) {
        return {
          background: this.option.barColor[index].color1 || [],
          boxShadow: 'inset 0px -5px 16px 3px ' + this.option.barColor[index].color1 || [],
          width: 50 + '%',
          height: 30 + '%',
          textAlign: this.option.textAlign
        };
      } else {
        return {
          background: this.option.barColor[index].color1 || [],
          boxShadow: 'inset 0px -5px 16px 3px ' + this.option.barColor[index].color1 || [],
          width: 70 + '%',
          height: 40 + '%',
          textAlign: this.option.textAlign
        };
      }
    },

    goLink(n, v) {
      const params = {
        name: n,
        value: v
      };
      this.progressClick(params);
    }
  }
};
</script>
<style lang="scss">
.tierbox {
  .tier {
    width: 100%;
    height: calc(100% - 20px);
    display: flex;
    padding-left: 20%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    .tiertext {
      color: #fff;
      display: inline-block;
      line-height: 10px;
      margin-left: -104%;
      margin-bottom: -1%;
      transform: scale(1, 1);
      box-sizing: border-box;
    }
    .circle {
      content: '';
      display: inline-block;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .valuediv {
      list-style: none;
      border-radius: 50%;
      transform: scale(1, 1.5);
    }
    .value {
      display: inline-block;
      vertical-align: baseline;
      padding-bottom: 30px;
    }
    .line {
      height: 2px;
      width: 40%;
      margin-left: -45%;
      margin-bottom: -1%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.2) 25%,
        rgba(255, 255, 255, 0.2) 75%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}
</style>
